export default [
	{
		dataIndex: 'created_at',
		key: 'datetime',
		title: 'Date Time',
		align: 'center',
		scopedSlots: {customRender: 'datetime'},
		width: 145
	},  {
		key: 'request',
		title: 'Merchant Name',
		scopedSlots: {customRender: 'request'}
	}, {
		key: 'services',
		title: 'Type',
		scopedSlots: {customRender: 'services'}
	}, {
		key: 'amount',
		title: 'Amount',
		scopedSlots: {customRender: 'amount'}
	}, {
		key: 'terminal_id',
		title: 'Terminal ID',
		scopedSlots: {customRender: 'terminal_id'}
	}, {
		key: 'merchant_id',
		title: 'Merchant ID',
		scopedSlots: {customRender: 'merchant_id'}
	}, {
		key: 'branch_code',
		title: 'Branch',
		scopedSlots: {customRender: 'branch_code'}
	}, {
		key: 'pan',
		title: 'PAN',
		scopedSlots: {customRender: 'pan'}
	}, {
		key: 'account_number',
		title: 'Account Number',
		scopedSlots: {customRender: 'account_number'}
	}, {
		key: 'original_account',
		title: 'Source Account Number',
		scopedSlots: {customRender: 'original_account'}
	}, {
		key: 'original_account_name',
		title: 'Source Account Name',
		scopedSlots: {customRender: 'original_account_name'}
	}, {
		key: 'destination_account',
		title: 'Destination Account',
		scopedSlots: {customRender: 'destination_account'}
	}, {
		key: 'destination_account_name',
		title: 'Destination Account Name',
		scopedSlots: {customRender: 'destination_account_name'}
	}, {
		key: 'rrn',
		title: 'RRN',
		scopedSlots: {customRender: 'rrn'}
	}, {
		key: 'stan',
		title: 'STAN',
		scopedSlots: {customRender: 'stan'}
	}, {
		key: 'status',
		title: 'response',
		scopedSlots: {customRender: 'status'}
	}, {
		key: 'rc',
		title: 'Response Code',
		scopedSlots: {customRender: 'rc'}
	}, {
		key: 'rc_description',
		title: 'Response Code Description',
		scopedSlots: {customRender: 'rc_description'}
	}, {
		key: 'response',
		title: 'Raw Response',
		scopedSlots: {customRender: 'response'}
	}
]
